module.exports = "<div class=\"yc-demo\">\n  <span data-bind=\"text:text\"></span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/demo/index.html
// module id = 369
// module chunks = 0